<template lang="pug">
    box-loader(
        :error="error"
        :loading="loading"
        @retry="retry()"
    )
</template>

<script>
import SubscriptionMixin from '@js/mixins/subscription';

export default {
    mixin: [SubscriptionMixin],

    props: {
        name: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            loading: true,
            error: false,
        };
    },

    mounted() {
        this.createVuexSubscription(`${this.name}/LOADING`, () => {
            this.loading = true;
            this.error = false;
        });

        this.createVuexSubscription(`${this.name}/LOADED`, () => {
            this.loading = false;
            this.error = false;
        });

        this.createVuexSubscription(`${this.name}/ERROR`, e => {
            this.error = true;
        });
    },

    methods: {
        retry() {
            this.$parent.getData();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/datatable-loader/datatable-loader.vue